import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { DatadogSessionReplayMask } from 'features/observability/rum/datadog-session-replay-mask';
import { Typography } from 'ucl/components/text/Typography';

import { IServerOrder } from '@rbi-ctg/menu';
import { t } from 'state/intl/translations';

import { CardHeading, CardHeadingContainer, CardText } from '../styled';

const DeliveryInfo = ({ serverOrder }: { serverOrder: IServerOrder }) => {
  const { delivery, cart } = serverOrder;

  return (
    <CardHeadingContainer>
      <CardHeading>{t('deliveryInfo')}</CardHeading>

      <Box marginTop="$4">
        <DatadogSessionReplayMask>
          <CardText testID="order-confirmation-customer-name" data-private>
            {cart.customerName}
          </CardText>
        </DatadogSessionReplayMask>
        <DatadogSessionReplayMask>
          <CardText testID="order-confirmation-dropoff-address" data-private>
            {`${delivery?.dropoff.addressLine1}\n`}
            {!!delivery?.dropoff.addressLine2 && (
              <>{`${t('unitNumber', { unitNumber: delivery?.dropoff.addressLine2 })}\n`}</>
            )}
            {delivery?.dropoff.city}, {delivery?.dropoff.state} {delivery?.dropoff.zip}
          </CardText>
        </DatadogSessionReplayMask>
        {!!delivery?.dropoff.phoneNumber && (
          <DatadogSessionReplayMask>
            <CardText testID="order-confirmation-phone-number" data-private>
              {delivery?.dropoff.phoneNumber}
            </CardText>
          </DatadogSessionReplayMask>
        )}
        {!!delivery?.instructions && (
          <DatadogSessionReplayMask>
            <CardText
              testID="order-confirmation-instructions"
              data-private
              style={{ marginTop: 4 }}
            >
              <Typography>{t('deliveryInstructions')}: </Typography>
              {`\n${delivery?.instructions}`}
            </CardText>
          </DatadogSessionReplayMask>
        )}
      </Box>
    </CardHeadingContainer>
  );
};

export default DeliveryInfo;
